// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f516c339","732":"9298c6ce","977":"6bf74232"}[chunkId] + ".chunk.js";
};